import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';

@Component({
  selector: 'app-communication-records',
  templateUrl: './communication-records.page.html',
  styleUrls: ['./communication-records.page.scss'],
})
export class CommunicationRecordsPage implements OnInit {
  communicationRecords:any; //信息反馈
  _type:any;
  // @Input() name: any;
  snc_name:any;
  time:any;
  constructor(
    public modalController: ModalController,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
  ) { 
    this.time=this.com.getNowdate.replace(/-/g,"/");
    this.snc_name=this.com.GetAccount.DisplayName;
  }

  ngOnInit() {
  }
  RecordsInput(e){
    let that=this;
   if(e&&e.target.value){
     if(e.target.value.length>120){
       e.target.value=e.target.value.substr(0,120);
       that.communicationRecords=e.target.value;
      }else{
       that.communicationRecords=e.target.value;
      }
    }
  }
   // 取消
   dismissModal() {
    const that=this;
    let _array:Array<any> = new Array<any>();
    this.modalController.dismiss({
      "modalStatus": false,
      "type":that._type,
      "Result":"",
      "info": '0'
    });
  }
  // 确定
  comfireModal() {
    const that=this;
    //debugger;
    // let _array:Array<any> = new Array<any>();
    // _array= that.arrayList.filter(item=>item.isCheck);
    // if(_array.length<=0){
    //   that.msg.Alert("请选择一家门店");
    //   return;
    // }
    if(!that.communicationRecords){
      that.msg.Alert("沟通记录不能为空");
      return;
    }
    that.modalController.dismiss({
      "modalStatus":true,
      "type":that._type,
      "Result":that.communicationRecords,
      "info": "是的"
    });
  }

}
